import type { AssistantTask } from "./assistantTaskTypes";

type Props = {
  tasks: AssistantTask[];
  onOpen: (taskId: string) => void;
};

function primaryRunning(tasks: AssistantTask[]): AssistantTask | null {
  return tasks.find((t) => t.status === "running") || tasks[0] || null;
}

export default function AssistantTaskWidget({ tasks, onOpen }: Props) {
  const active = tasks.filter((t) => t.status === "running");
  const recent = tasks.filter((t) => t.status !== "running").slice(0, 2);
  const show = active.length > 0 || recent.length > 0;
  if (!show) return null;

  const main = primaryRunning(active.length ? active : tasks);
  if (!main) return null;

  const running = main.status === "running";

  return (
    <div className="asstTaskWidgetWrap">
      <button
        type="button"
        className={"asstTaskWidget" + (running ? " running" : main.status === "failed" ? " fail" : " done")}
        title="Open assistant task details"
        onClick={() => onOpen(main.id)}
      >
        <span className="asstTaskWidgetIcon" aria-hidden="true">
          {running ? <span className="asstTaskWidgetSpinner" /> : main.status === "completed" ? "✓" : "!"}
        </span>
        <span className="asstTaskWidgetText">
          <span className="asstTaskWidgetTitle">{running ? "Creating page…" : main.title}</span>
          <span className="asstTaskWidgetSub">
            {running
              ? `${main.progress}% · ${main.steps.find((s) => s.status === "active")?.label || "Working"}`
              : main.subtitle || main.status}
          </span>
        </span>
        {active.length > 1 ? <span className="asstTaskWidgetBadge">{active.length}</span> : null}
      </button>
    </div>
  );
}
